<nav class="navigation-tabs">
  <ul>
    <li (click)="onChangeProject(project)" *ngFor="let project of sharedProjects; let i = index">
      <a>
        <span  [ngClass]="{'currentStep' : project.id === currentProject.id}">{{ i === 0 ? ('T_COLLABORATIVE_INITIAL' | translate) : project.spaceName}}</span></a>
    </li>
  </ul>
</nav>
